import type { CatalogRepository } from '#/domain/catalog/CatalogRepository'
import type { MetricCategory } from '#/domain/catalog/MetricCategory'

export class GetCatalogMetricCategoryListUseCase {
  constructor(private readonly repository: CatalogRepository) {}

  async execute(): Promise<MetricCategory[]> {
    return this.repository.findMetricCategories()
  }
}
